import { ListProgrammaticCampaignsRO } from "@intentsify/dto";
import {
  ProgrammaticCampaign,
  ProgrammaticCampaignMeta,
} from "@intentsify/types";
import { apiService, Endpoints } from "api";
import { FetchDataParamsWithToken } from "types";

export const listPaginatedProgrammaticCampaigns = async (
  params: FetchDataParamsWithToken<keyof ProgrammaticCampaign> & {
    includeAllCompanies?: boolean;
  }
): Promise<ListProgrammaticCampaignsRO> => {
  const { data } = await apiService.get<ListProgrammaticCampaignsRO>(
    Endpoints.ProgrammaticCampaigns.Get.Paginated,
    {
      params,
    }
  );

  return data;
};

export const getProgrammaticCampaign = async (
  programmaticCampaignId: string
): Promise<ProgrammaticCampaign> => {
  const { data } = await apiService.get<ProgrammaticCampaign>(
    Endpoints.ProgrammaticCampaigns.Get.ById(programmaticCampaignId)
  );
  return data;
};

export const listProgrammaticCampaignMeta = async (
  programmaticCampaignId: string
): Promise<ProgrammaticCampaignMeta> => {
  const { data } = await apiService.get<ProgrammaticCampaignMeta>(
    Endpoints.ProgrammaticCampaigns.Get.Campaigns(programmaticCampaignId)
  );
  return data;
};
